export default {
  ratingAriaLabel: {
    id: 'product_page_sticky_bar_rating_aria_label',
    defaultMessage: '{rating} stars out of 5',
  },
}
